export const CallingStatusValues = [
  'Uncalled',
  'Skipped',
  'No answer',
  'Answered',
  'Meaningful interaction',
];
